import { render, staticRenderFns } from "./ExportGlobeOperationFolder.vue?vue&type=template&id=47b9cff5&scoped=true&"
import script from "./ExportGlobeOperationFolder.vue?vue&type=script&lang=js&"
export * from "./ExportGlobeOperationFolder.vue?vue&type=script&lang=js&"
import style0 from "./ExportGlobeOperationFolder.vue?vue&type=style&index=0&id=47b9cff5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b9cff5",
  null
  
)

export default component.exports